var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('em',{staticClass:"paging-summary"},[(_vm.last > 0)?_c('span',[_vm._v(_vm._s(_vm.first)+" - "+_vm._s(_vm.last)+" of ")]):_vm._e(),_vm._v(_vm._s(_vm.meta.total_results)+" record(s) found")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381e28ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PagingSummary.vue
// module id = null
// module chunks = 